export const GET_FUNDING_SUCCESS = 'GET_FUNDING_SUCCESS';
export const SET_FUNDING_LOADING = 'SET_FUNDING_LOADING';

export const GET_OFFERINGS_SUCCESS = 'GET_OFFERINGS_SUCCESS';
export const SET_OFFERINGS_LOADING = 'SET_OFFERINGS_LOADING';
